import React from "react";
import AppModal from "../common/AppModal";
import CreateOrUpdateClassroomForm from "../../forms/CreateOrUpdateClassroomForm";

interface CreateClassroomModalProps {
  open: boolean;
  onClose: () => void;
  loading: boolean;
  error: string | null;
}

const CreateClassroomModal: React.FC<CreateClassroomModalProps> = ({
  open,
  onClose,
  loading,
  error,
}) => (
  <AppModal
    open={open}
    onClose={onClose}
    title="Create New Classroom"
    width="md"
    loading={loading}
  >
    <CreateOrUpdateClassroomForm loading={loading} error={error} />
  </AppModal>
);

export default CreateClassroomModal;
